import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Problem from './components/Problem';
import DetailedFeatures from './components/DetailedFeatures';
import Features from './components/Features';
import KeyDifference from './components/KeyDifference';
import WhoIsItFor from './components/WhoIsItFor';
import GoldMembership from './components/GoldMembership';
import CallToAction from './components/CallToAction';
import GDPRCompliance from './components/GDPRCompliance';
import Footer from './components/Footer';
import AffiliatePage from './components/AffiliatePage';
import styles from './styles';

const globalStyles = `
  @import url('https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Montserrat:wght@400;700&family=Open+Sans:wght@400;600;700&display=swap');

  * {
    box-sizing: border-box;
  }

  body {
    margin: 0;
    font-family: 'Open Sans', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    user-select: none;
  }

  h1, h2, h3, h4, h5, h6 {
    font-family: 'Montserrat', sans-serif;
    font-weight: 700;
  }
`;

function HomePage() {
  return (
    <div style={styles.appContainer}>
      <style>{globalStyles}</style>
      <Header />
      <main>
        <Hero />
        <Problem />
        <DetailedFeatures />
        <Features />
        <KeyDifference />
        <WhoIsItFor />
        <GoldMembership />
        <CallToAction />
        <GDPRCompliance />
        {/* <Contact /> */}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Affiliate landing page — must be before the catch-all */}
        <Route path="/a/:partnerCode" element={<AffiliatePage />} />

        {/* Home page (catch-all) */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;